<template>
  <v-row>
    <!-- kitchen sink -->
    <v-col cols="12">
      <app-card-code
        :title="`${$t('menu.configuration')} / API`"
      >
        <ApiKeys></ApiKeys>
      </app-card-code>
    </v-col>
  </v-row>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import AppCardCode from '@/@core/components/app-card-code/AppCardCode.vue'

// eslint-disable-next-line import/no-unresolved
import ApiKeys from './tablas/ApiKeys.vue'

export default {
  components: {
    AppCardCode,
    ApiKeys,
  },
}
</script>
